"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SiteCard = exports.SiteCardDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var entity_card_1 = require("./entity-card");
var entity_value_1 = require("./entity-value");
var entity_multi_value_list_1 = require("./entity-multi-value-list");
var coalesce_1 = require("../../utils/coalesce");
var lodash_1 = require("lodash");
var menu_context_1 = require("../context/menu-context");
var use_modal_1 = require("../../hooks/use-modal");
var use_lang_1 = require("../../hooks/use-lang");
var site_rebuild_dialog_1 = require("./site-rebuild-dialog");
var icons_1 = require("../icons");
exports.SiteCardDefaultProps = {};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), theme_1.theme.COLOR('text'))
});
var LinkedStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", ";\n    margin-top: ", ";\n    padding-top: ", ";\n  "], ["\n    ", ";\n    margin-top: ", ";\n    padding-top: ", ";\n  "])), theme_1.theme.H_DOT_BG(), theme_1.theme.UNIT(3), theme_1.theme.UNIT(4))
});
var LayoutStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", ";\n    padding-bottom: ", ";\n  "], ["\n    ", ";\n    padding-bottom: ", ";\n  "])), LinkedStyles, theme_1.theme.UNIT(1))
});
var PagesStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding: 0;\n    padding-top: ", ";\n  "], ["\n    padding: 0;\n    padding-top: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var FooterStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    margin-top: -", ";\n    padding-bottom: ", ";\n  "], ["\n    margin-top: -", ";\n    padding-bottom: ", ";\n  "])), theme_1.theme.UNIT(2), theme_1.theme.UNIT(3))
});
var UrlStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    font-weight: 500;\n    text-decoration: none;\n    font-size: 1.0em;\n    padding-top: ", ";\n    color: ", ";\n    ", ";\n  "], ["\n    font-weight: 500;\n    text-decoration: none;\n    font-size: 1.0em;\n    padding-top: ", ";\n    color: ", ";\n    ", ";\n  "])), theme_1.theme.UNIT(3), theme_1.theme.COLOR('dark'), theme_1.theme.H_DOT_BG())
});
var RebuildDialogStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var OwnerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: (0, styled_components_1.default)(entity_card_1.EntityCard)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Url: styled_components_1.default.span(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), UrlStyles),
  RebuildDialog: (0, styled_components_1.default)(site_rebuild_dialog_1.SiteRebuildDialog)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), RebuildDialogStyles),
  Layout: (0, styled_components_1.default)(entity_value_1.EntityValue)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), LayoutStyles),
  Owner: (0, styled_components_1.default)(entity_value_1.EntityValue)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), LayoutStyles),
  Pages: (0, styled_components_1.default)(entity_multi_value_list_1.EntityMultiValueList)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), PagesStyles),
  Footer: styled_components_1.default.div(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), FooterStyles)
};
var SiteCard = function (props) {
  var className = props.className,
    entity = props.entity;
  var _a = entity.pages,
    pages = _a === void 0 ? [] : _a,
    url = entity.url,
    owner = entity.owner;
  var description = (0, coalesce_1.coalesce)(entity, ['summary.text', 'description.text', 'openGraph.description.text']);
  var t = (0, use_lang_1.useLang)();
  var modal = (0, use_modal_1.useModal)();
  var hasDescription = !!description;
  return react_1.default.createElement(menu_context_1.MenuProvider, {
    value: {
      preventDelete: true,
      extraItems: [{
        label: t('Rebuild {{SITE}}...'),
        value: 'rebuild',
        icon: react_1.default.createElement(icons_1.Icons.ChevronUpCircle, null),
        onClick: function (event) {
          event.preventDefault();
          modal.show(react_1.default.createElement(My.RebuildDialog, {
            entity: entity
          }));
        }
      }]
    }
  }, react_1.default.createElement(My.Container, {
    entity: entity,
    className: className,
    showFollowControls: false,
    afterDescription: react_1.default.createElement(My.Footer, null, react_1.default.createElement(My.Pages, {
      maxItems: hasDescription ? 3 : 8,
      headerLabel: "Pages",
      items: (0, lodash_1.sortBy)(pages, 'name')
    }))
  }, react_1.default.createElement(My.Url, null, url), owner && react_1.default.createElement(My.Owner, {
    label: "{{SITE}} Owner",
    entity: owner
  })));
};
exports.SiteCard = SiteCard;
exports.SiteCard.defaultProps = exports.SiteCardDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15;